<template>
  <button
    class="btn"
    @click="handleClick"
    :disabled="disabled ? disabled : loading"
    :type="nativeType"
    :class="[
      type ? 'btn-' + type : '',
      size ? 'btn-' + size : '',
      block ? 'btn-' + block : '',
      {
        'disabled': disabled ? disabled : loading
      }
    ]">
    <i class="el-icon-loading" v-if="loading"></i>
    <i :class="icon" v-if="icon && !loading"></i>
    <span v-if="$slots.default"><slot></slot></span>
  </button>
  <!--'is-loading': loading,-->
</template>
<script>
  export default {
    name: 'EButton',
    props: {
      type: {
        type: String,
        default: 'default'
      },
      size: String,
      block: String,
      icon: {
        type: String,
        default: ''
      },
      nativeType: {
        type: String,
        default: 'button'
      },
      loading: Boolean,
      disabled: Boolean
    },

    methods: {
      handleClick(evt) {
        this.$emit('click', evt);
      }
    }
  };
</script>
<style lang="less" scoped>
  .btn {
    border-radius: 4px;
    outline: none !important;
  }

  .btn-primary {
    font-weight: 300;
    background: #D0352C;
    border: 1px solid #D0352C;
    &:hover {
      background: #C0393E;
      border: 1px solid #C0393E;
    }
  }

  .btn-link {
    color: #419BFF;
  }
</style>



// WEBPACK FOOTER //
// src/plugin-api/packages/button/src/button.vue